import { c as _c } from "react-compiler-runtime";
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useFDTContextMenuConfig } from '../../contextMenu/context/FDTContextMenuConfigContext';
import { shouldBypassContextMenu } from '../../contextMenu/shouldBypassContextMenu';
import { useMemo } from 'react';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { getCellExternalId } from '../utils/cellIdUtils';
import { useIsCellSelectionEnabled, useCellSelectionScopeId } from '../../cellSelection/context/CellSelectionContext';
import { useCellSelectionSelector } from '../../redux/reduxHooks';
import { makeGetIsFillHandleCell, makeGetCellSelectionEdges } from '../../cellSelection/redux/cellSelectionSlice';
import { useCellSelectionHandlers } from '../../cellSelection/hooks/useCellSelectionHandlers';
import { CELL_SELECTED_ATTRIBUTE, CELL_SELECTABLE_ATTRIBUTE, FILL_HANDLE_ATTRIBUTE, CELL_EDGES_ATTRIBUTE } from '../constants/cellSelectionAttributes';
import { jsx as _jsx } from "react/jsx-runtime";
const Cell = t0 => {
  const $ = _c(53);
  const {
    CellComponent,
    columnIndex,
    rowIndex,
    columnNamespace,
    columnName,
    rowId,
    row,
    isCellVisible
  } = t0;
  let t1;
  if ($[0] !== columnName || $[1] !== columnNamespace || $[2] !== rowId) {
    t1 = getCellExternalId(columnNamespace, columnName, rowId);
    $[0] = columnName;
    $[1] = columnNamespace;
    $[2] = rowId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const externalId = t1;
  const contextMenuConfig = useFDTContextMenuConfig();
  const triggerContextMenu = contextMenuConfig === null || contextMenuConfig === void 0 ? void 0 : contextMenuConfig.triggerContextMenu;
  const isCellSelectionEnabled = useIsCellSelectionEnabled();
  const cellSelectionScopeId = useCellSelectionScopeId();
  let t2;
  if ($[4] !== columnIndex || $[5] !== rowIndex) {
    t2 = makeGetCellSelectionEdges(rowIndex, columnIndex);
    $[4] = columnIndex;
    $[5] = rowIndex;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const cellSelectionEdges = useCellSelectionSelector(t2);
  const isCellSelected = cellSelectionEdges !== null;
  let t3;
  if ($[7] !== columnIndex || $[8] !== rowIndex) {
    t3 = makeGetIsFillHandleCell(rowIndex, columnIndex);
    $[7] = columnIndex;
    $[8] = rowIndex;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const isFillHandleCell = useCellSelectionSelector(t3);
  const cellSelectionHandlers = useCellSelectionHandlers(rowIndex, columnIndex, isFillHandleCell);
  let t4;
  if ($[10] !== columnName || $[11] !== columnNamespace) {
    t4 = columnNamespace === CONTACT_TYPE_ID && ["name", "email"].includes(columnName) ? {
      "data-onboarding": `contact-${columnName}-cell`
    } : {};
    $[10] = columnName;
    $[11] = columnNamespace;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const onboardingSelectors = t4;
  let t5;
  if ($[13] !== columnName || $[14] !== columnNamespace || $[15] !== row || $[16] !== triggerContextMenu) {
    t5 = triggerContextMenu ? e => {
      if (shouldBypassContextMenu(e)) {
        return;
      }
      const handled = triggerContextMenu({
        row,
        columnName,
        columnNamespace
      });
      if (handled === true) {
        e.preventDefault();
        e.stopPropagation();
      }
    } : undefined;
    $[13] = columnName;
    $[14] = columnNamespace;
    $[15] = row;
    $[16] = triggerContextMenu;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== columnIndex || $[19] !== externalId || $[20] !== onboardingSelectors || $[21] !== rowIndex || $[22] !== t5) {
    t6 = Object.assign({
      id: externalId,
      "data-table-external-id": externalId,
      "data-test-id": externalId,
      onContextMenu: t5
    }, onboardingSelectors, {
      "data-column-index": columnIndex,
      "data-fdt-row-index": rowIndex
    });
    $[18] = columnIndex;
    $[19] = externalId;
    $[20] = onboardingSelectors;
    $[21] = rowIndex;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  const baseCellProps = t6;
  let t7;
  if ($[24] !== baseCellProps || $[25] !== cellSelectionEdges || $[26] !== cellSelectionHandlers || $[27] !== cellSelectionScopeId || $[28] !== isCellSelected || $[29] !== isCellSelectionEnabled || $[30] !== isFillHandleCell) {
    t7 = isCellSelectionEnabled ? Object.assign({}, baseCellProps, cellSelectionHandlers, {
      [CELL_SELECTABLE_ATTRIBUTE]: cellSelectionScopeId
    }, isCellSelected && {
      [CELL_SELECTED_ATTRIBUTE]: true,
      [CELL_EDGES_ATTRIBUTE]: cellSelectionEdges
    }, isFillHandleCell && {
      [FILL_HANDLE_ATTRIBUTE]: true
    }) : baseCellProps;
    $[24] = baseCellProps;
    $[25] = cellSelectionEdges;
    $[26] = cellSelectionHandlers;
    $[27] = cellSelectionScopeId;
    $[28] = isCellSelected;
    $[29] = isCellSelectionEnabled;
    $[30] = isFillHandleCell;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  const requiredCellProps = t7;
  if (!isCellVisible) {
    let t8;
    if ($[32] !== requiredCellProps) {
      t8 = /*#__PURE__*/_jsx("td", Object.assign({}, requiredCellProps));
      $[32] = requiredCellProps;
      $[33] = t8;
    } else {
      t8 = $[33];
    }
    return t8;
  }
  let t8;
  if ($[34] !== CellComponent || $[35] !== columnIndex || $[36] !== columnName || $[37] !== columnNamespace || $[38] !== requiredCellProps || $[39] !== row || $[40] !== rowIndex) {
    t8 = /*#__PURE__*/_jsx(CellComponent, {
      rowIndex: rowIndex,
      columnIndex: columnIndex,
      columnNamespace: columnNamespace,
      columnName: columnName,
      row: row,
      requiredCellProps: requiredCellProps
    });
    $[34] = CellComponent;
    $[35] = columnIndex;
    $[36] = columnName;
    $[37] = columnNamespace;
    $[38] = requiredCellProps;
    $[39] = row;
    $[40] = rowIndex;
    $[41] = t8;
  } else {
    t8 = $[41];
  }
  const cellElement = t8;
  const isContextMenuOpen = contextMenuConfig === null || contextMenuConfig === void 0 ? void 0 : contextMenuConfig.getIsContextMenuOpen({
    row,
    columnName,
    columnNamespace
  });
  if (contextMenuConfig !== null && contextMenuConfig !== void 0 && contextMenuConfig.ContextMenuContentComponent && isContextMenuOpen) {
    let t9;
    if ($[42] !== columnName || $[43] !== columnNamespace || $[44] !== contextMenuConfig.ContextMenuContentComponent || $[45] !== row) {
      t9 = /*#__PURE__*/_jsx(contextMenuConfig.ContextMenuContentComponent, {
        columnName: columnName,
        columnNamespace: columnNamespace,
        row: row
      });
      $[42] = columnName;
      $[43] = columnNamespace;
      $[44] = contextMenuConfig.ContextMenuContentComponent;
      $[45] = row;
      $[46] = t9;
    } else {
      t9 = $[46];
    }
    let t10;
    if ($[47] !== triggerContextMenu) {
      t10 = () => {
        triggerContextMenu === null || triggerContextMenu === void 0 || triggerContextMenu({
          columnName: null,
          columnNamespace: null,
          row: null
        });
      };
      $[47] = triggerContextMenu;
      $[48] = t10;
    } else {
      t10 = $[48];
    }
    let t11;
    if ($[49] !== cellElement || $[50] !== t10 || $[51] !== t9) {
      t11 = /*#__PURE__*/_jsx(Popover, {
        arrowSize: "small",
        closeOnOutsideClick: true,
        content: t9,
        "data-test-id": "context-menu-popover",
        onOpenChange: t10,
        open: true,
        placement: "bottom right",
        children: cellElement
      });
      $[49] = cellElement;
      $[50] = t10;
      $[51] = t9;
      $[52] = t11;
    } else {
      t11 = $[52];
    }
    return t11;
  }
  return cellElement;
};
export default Cell;